import { OptimizelyLongString } from "..";
import { OptimizelyBlockExpandedValue } from "../expanded";

export interface ImageFileBlockData extends OptimizelyBlockExpandedValue {
    contentType: ['Block', 'Media', 'ImageFile'];
    alt: OptimizelyLongString;
    url: string;
};

export const isImageFileBlockData = (
    block: OptimizelyBlockExpandedValue
  ): block is ImageFileBlockData => {
    return block.contentType[2] === 'ImageFile';
  };